import { Error } from '../models/error';
export const ADD_ERROR = '[Error] ADD ERROR';
export const REMOVE_ERROR = '[Error] REMOVE ERROR';
export const REMOVE_ERROR_BY_ID = '[Error] REMOVE ERROR BY ID';
export const CLEAR_ALL_ERRORS = '[Error] CLEAR ALL ERRORS';
export class Fail {
    constructor(input) {
        this.isFailAction = true;
        if (input instanceof Error) {
            this.payload = input;
        }
        else if (typeof input === 'string') {
            this.payload = new Error({ message: input });
        }
        else {
            // action.payload is ErrorOptions
            this.payload = new Error(input);
        }
    }
}
export class Add extends Fail {
    constructor() {
        super(...arguments);
        this.type = ADD_ERROR;
    }
}
export class Remove {
    constructor(payload) {
        this.payload = payload;
        this.type = REMOVE_ERROR;
    }
}
export class RemoveById {
    constructor(payload) {
        this.payload = payload;
        this.type = REMOVE_ERROR_BY_ID;
    }
}
export class Clear {
    constructor() {
        this.type = CLEAR_ALL_ERRORS;
    }
}
//# sourceMappingURL=error.actions.js.map